module.exports = __webpack_public_path__ + "static/media/persona2.f60a180b.png";